<div *ngIf="showBanner">
  <div class="relative">
    
    <img [src]="imageUrl" 
         [alt]="gift | translate" 
         class="w-full h-[320px] object-cover object-bottom" />
    
    <div class="absolute bottom-0 left-0 right-0 bg-black text-white typography-title-s p-4">
      <span [innerHTML]="'mypoints.BANNER_MESSAGE' | translate: {
          sales: requiredSales,
          gift: gift,
          level: loyaltyLevel?.toLowerCase()
        }">
      </span>
    </div>
  
  </div>
</div>